import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLufthansaComponent } from './simple-icons-lufthansa.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLufthansaComponent ],
    exports:      [ SimpleIconsLufthansaComponent ],
    bootstrap:    []
})
export class SimpleIconsLufthansaModule {}
